// extracted by mini-css-extract-plugin
export default {"items":"CharacterItem_items__qOGdD","button":"CharacterItem_button__5m7uy","spaceup":"CharacterItem_spaceup__vxcFS"};